export default __webpack_public_path__ + "static/media/death_rate_leading_cause_by_race.10dbbce3.png";